import React, { Component } from 'react'
import SetupManager from './qzSetup/SetupManager'
import InstallationCheck from './qzSetup/InstallationCheck'
import ConnectionCheck from './qzSetup/ConnectionCheck'
import VersionCheck from './qzSetup/VersionCheck'
import PrinterCheck from './qzSetup/PrinterCheck'
import { getQzConfig } from '../config'

export default class Setup extends Component {
	render() {
		return (
			<SetupManager>
				<InstallationCheck />
				<ConnectionCheck />
				<VersionCheck />
				<PrinterCheck printerName={getQzConfig().printerName} />
			</SetupManager>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/Setup.js